import { IProfessional } from '../iprofessional';



export interface IProfessionalState {
    professional: IProfessional,
    professionals: Array<IProfessional>,
    error?: any
}
